import { VideoSection } from "@domain/lms/course/courseSection";
import { SectionController } from "@ui/pages/lms/courseEditorPage/courseEditorController/sectionController";

export class VideoSectionController extends SectionController<VideoSection> {
	setUrl(url: string): void {
		this.sectionUpdater((section) => ({ ...section, url }));
	}
}
